import { Col, Form, Row, Typography } from "antd";
import { MazakaButton } from "apps/Common/MazakaButton";
import { MazakaForm } from "apps/Common/MazakaForm";
import useMazakaForm from "hooks/useMazakaForm";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { addContract, editContract, getContractDetails } from "../../Services";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { MazakaInput } from "apps/Common/MazakaInput";
import { useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import GeneralAllContractType from "apps/Common/Contract/GeneralAllContractType";
import useCapitalize from "apps/Common/Adress/helpers/useCapitalize";

const BasicInfos = (props: any) => {
  const [form] = Form.useForm();
  const {userInfoes} = useSelector((state:RootState)=>state.profile)
  const [searchParams,setSearchParams] = useSearchParams()
  const { formActions, mazakaForm } = useMazakaForm(form);
  const {capitalize} = useCapitalize()
  const [contractData,setContractData] = useState<any>()
  const contractId = searchParams.get("contractId");

  useEffect(() => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set("key", "basicInfoes");
      return newParams;
    });
  }, []);


const setInitialData = async(contractId:string)=>{
try {
  const response = await getContractDetails(contractId)
  if(response?.data)
  {
    setContractData(response?.data)
    form.setFieldsValue({
      ...response?.data
    })

  }
} catch (error:any) {
  openNotificationWithIcon("default",error?.message)
}
}

useEffect(()=>{
  if(contractId)
  {
    setInitialData(contractId)
  }
  else{
    form.setFieldValue("advisorName",`${userInfoes?.name||""} ${userInfoes?.surname||""}`)
  }
},[contractId])

  const handleOnFinish = async() => {
    mazakaForm.setLoading()
    let formValues = form.getFieldsValue()
    try {
      if(contractData)
      {
        const response:any = await editContract({...contractData,...formValues})
        setSearchParams((prev) => {
          const newParams = new URLSearchParams(prev);
          newParams.set("contractId", response?.data?.id);
          return newParams;
        });
       
      }
      else{
        const response = await addContract(formValues)
       
        setSearchParams((prev) => {
          const newParams = new URLSearchParams(prev);
          newParams.set("contractId", response?.data?.id);
          return newParams;
        });
      }
      mazakaForm.setSuccess(2000,()=>"İşlem Başarılı")
      props.setSelectedKey("customerDetails")
     
      
    } catch (error:any) {
      mazakaForm.setFailed(2000,error?.message)
    }

  };

  return (
    <>
      <Col span={24}>
        <MazakaForm
          submitButtonVisible={false}
          form={form}
          initialValues={{contractTypeId:2002}}
          onFinish={handleOnFinish}
        >
          <Row gutter={[10, 20]} className="">
          <MazakaInput
              xs={24}
              name={"advisorName"}
              label={"Danışman Adı Soyadı"}
              className="!m-0"
              placeholder={"Danışman"}
              disabled={userInfoes?.name&&userInfoes.surname}
      
              rules={[{required:true,message:""}]}
            />
              <GeneralAllContractType
              xs={24}
              name={"contractTypeId"}
              label={"Tür"}
              className="!m-0"
              placeholder={"Tür"}
              rules={[{required:true,message:""}]}
            />
           

            <Col span={24}>
              <MazakaButton
                className="!p-4 !bg-[#FFC502] !text-black"
                htmlType="submit"
                block
                processType={formActions.submitProcessType}
              >
                Kaydet ve Devam Et
              </MazakaButton>
            </Col>
          </Row>
        </MazakaForm>
      </Col>
    </>
  );
};

export default BasicInfos;
